import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vk",
  "use": "icon-vk-usage",
  "viewBox": "0 0 24 15",
  "content": "<symbol viewBox=\"0 0 24 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vk\"><path d=\"M13.2185 14.9888C5.10997 14.9888 0.190922 9.35532 0 0H4.11043C4.23397 6.87032 7.36734 9.79385 9.75948 10.3898V0H13.6902V5.93703C16.0037 5.67841 18.4183 2.97976 19.227 0H23.1015C22.4839 3.66567 19.8446 6.36432 17.9916 7.47751C19.8559 8.37706 22.8432 10.7384 24 15H19.7436C18.8451 12.1552 16.6439 9.95127 13.6902 9.64768V15H13.2185V14.9888Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol